<template>
	<div id="face-desktop">
		<div style="height: auto; overflow: auto">
			<clientes v-if="menu == 'CLIENTES'" :menu="menu"></clientes>
			<facturacion v-if="menu == 'FACTURACION'" :menu="menu"></facturacion>
			<reporte v-if="menu == 'REPORTE'" :menu="menu"></reporte>
			<refacturacion v-if="menu == 'REFACTURACION'" :menu="menu"></refacturacion>
			<dtemanual v-if="menu == 'DTEMANUAL'" :menu="menu"></dtemanual>
		</div>
	</div>
</template>
<script lang="ts">

	import Clientes from "./Clientes/main.vue";
	import Facturacion from "./Facturacion/main.vue";
	import Reporte from "./Reporte/main.vue";
	import Refacturacion from "./Refacturacion/main.vue";
	import DteManual from "./DTEManual/main.vue";


	export default 
	{
		name: "Desktop",
		components: { Clientes, Facturacion, Reporte, Refacturacion, DteManual },
		props: {
			menu: String
		}
	}
</script>
<style scoped>

	#face-desktop {
		position: absolute;
		top: 125px;
		width: 100%;
		height: Calc(100% - 145px);
		overflow: auto;
	}

</style>
